import { FadeUp } from "@/components/Reveal";

const HEX = "[clip-path:polygon(50%_0%,100%_25%,100%_75%,50%_100%,0%_75%,0%_25%)]";
const PEX = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940`;
const UNS = (id) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=85`;

const APPS = [
  { label: "Ridges", img: PEX(34414978) },
  { label: "Ponds", img: PEX(18538069) },
  { label: "Pipelines", img: PEX(29274530) },
  { label: "Foundations", img: PEX(36657008) },
  { label: "Farmland levelling", img: UNS("1613928270169-4e4462c75a79") },
  { label: "Road slopes", img: UNS("1765972280045-7d0e47b376e3") },
  { label: "Ditches", img: UNS("1603816886392-25f1d28406d9") },
  { label: "Groundworks", img: UNS("1534097575056-ddba81f714c8") },
];

function Tile({ label, img }) {
  const id = label.toLowerCase().replace(/\s+/g, "-");
  return (
    <FadeUp>
      <div className="group" data-testid={`p25d-app-${id}`}>
        <div className={`mx-auto aspect-[1/1.155] w-full max-w-[250px] bg-signal/40 p-[2px] ${HEX}`}>
          <div className={`h-full w-full overflow-hidden ${HEX}`}>
            <img
              src={img}
              alt={`${label} dug on grade with the CHCNAV EMG100`}
              loading="lazy"
              className="h-full w-full object-cover grayscale-[25%] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
            />
          </div>
        </div>
        <p className="mt-3 text-center font-mono text-[11px] uppercase tracking-[0.25em] text-fog transition-colors group-hover:text-neon">
          {label}
        </p>
      </div>
    </FadeUp>
  );
}

export default function ApplicationGrid() {
  return (
    <div className="mx-auto max-w-4xl space-y-4" data-testid="application-grid">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4 sm:pr-10">
        {APPS.slice(0, 4).map((a) => (
          <Tile key={a.label} {...a} />
        ))}
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4 sm:pl-10">
        {APPS.slice(4).map((a) => (
          <Tile key={a.label} {...a} />
        ))}
      </div>
    </div>
  );
}
